import { css, cx } from "@emotion/css";
import React from "react";
export function Em({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <em
      className={cx(
        css`
          display: inline-block;
          padding: 0 1rem;
          font-weight: bold;
          font-size: 1.8rem;
          text-decoration: underline;
        `,
        className
      )}
    >
      {children}
    </em>
  );
}
